module.exports = __webpack_public_path__ + "static/fonts/PingFang ExtraLight.e5e1a971.ttf";